<template lang="pug">
div
  .panel
    p {{ vacancy.summary }}
    div(v-html="vacancy.description")
  .panel
    VacancyReactionForm(:vacancy="vacancy")
</template>

<script>
import VacancyReactionForm from '@/components/VacancyReactionForm.vue'

export default {
  name: 'VacancyDescription',
  components: { VacancyReactionForm },
  props: {
    vacancy: { type: Object, required: true },
  },
}
</script>

<style scoped lang="stylus">
@import '~@/assets/_variables.styl'

.panel
  padding 4rem
  background-color vacancies-card-background-color
  box-shadow 0 2px 2px 0 rgba(127, 127, 127, 127)
  margin-bottom 3rem
</style>
